import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { splitVisitAction } from '../../../redux/actions/visitActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import SplitParts from './parts/SplitParts';
import SplitTasks from './tasks/SplitTasts';

const SplitVisit = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const { vin, id } = useSelector((state) => state.visit.visit);
  const [loading, setLoading] = useState(false);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [selectedParts, setSelectedParts] = useState([]);

  const onSubmit = async () => {
    setLoading(true);
    const body = { visitPartIds: selectedParts, visitTaskIds: selectedTasks };
    await dispatch(splitVisitAction(vin, id, body));
    setLoading(false);
    onModalClose();
  };

  return (
    <Modal
      title={'Розділення візиту'}
      loading={loading}
      onClose={onModalClose}
      body={
        <div className="flex flex-col gap-6">
          <SplitTasks loading={loading} selectedTasks={selectedTasks} setSelectedTasks={setSelectedTasks} />
          <SplitParts loading={loading} selectedParts={selectedParts} setSelectedParts={setSelectedParts} />
        </div>
      }
      actionButton={
        (selectedTasks.length || selectedParts.length) > 0 && (
          <Button onClick={onSubmit} disabled={loading} variant="primary">
            Розділити
          </Button>
        )
      }
    />
  );
};

export default SplitVisit;
